<script>
  import Header from "lib/components/Header.svelte";
  import ContentSwitcher from "lib/components/ContentSwitcher.svelte";
  import ButtonIcon from "lib/components/buttonIconOnly.svelte";
  import { fly } from "svelte/transition";
  import { fetchWithSession } from "lib/util/fetchWithSession.js";

  import {
    DataTable,
    DataTableSkeleton,
    Pagination,
    Toolbar,
    ToolbarContent,
    ToolbarSearch,
    Checkbox,
    Button,
    Modal,
  } from "carbon-components-svelte";

  import ButtonNew from "lib/components/ButtonNew.svelte";
  import { TextInput, TextArea, SectionWrapper } from "paxray-components-svelte";

  const urlParams = new URLSearchParams(window.location.search);
  const idproject = urlParams.get("idproject");

  let rowsKeyword = [];
  let allRowsKeyword = [];
  let type = "am_windowtitle";
  let generateKeywordsType = "keywords_ui";
  let allUiElements = [];

  let selectedKeywordIds = [];
  let loadingKeyword = false;
  let loadingWindowTitle = false;
  let defaultSortKeyword = { key: "keyword", order: "ascending" };
  let defaultSortWindowTitle = { key: "windowtitle", order: "ascending" };

  let hiddenKeyword = [];

  let onlyUnchecked = false;
  let onlyChecked = false;
  let onlyUnhidden = false;
  let onlyHidden = false;
  let onlyInWindows = false;
  let selectedIndex = 0;
  let selectedUIElementIndex = 0;

  let paginationWindowTitle = {
    page: 1,
    pageSize: 10,
    total: 0,
    totalPages: 0,
  };

  let paginationKeyword = {
    page: 1,
    pageSize: 10,
    total: 0,
    totalPages: 0,
  };
  let idAnonymization = 0;
  let regexModalOpen = false;
  let currentRegex = 0;
  let currentApplication = 0;
  let allwindowtitles = [];
  let preview = "";
  let regexRules = [];
  let rowsWindowTitle = [];
  let regexRule = {
    name: "",
    applicationname: "",
    search: "",
    replace: "",
  };

  $: headersKeyword = [
    { key: "keyword", value: "Keyword" },
    { key: "applicationname", value: "App" },
    {
      key: "nrecords",
      value: selectedIndex === 0 ? "#WinTitle" : "#UI Element",
    },
    { key: "hide", value: "Hide" },
  ];

  $: headersWindowTitle = [
    { key: "applicationname", value: "Application" },
    { key: selectedIndex === 0 ? "windowtitle": "name", value: selectedIndex === 0 ? "Window Title" : "UI Element" },
    { key: "count", value: "Count" },
  ];

  $: generateKeywordsType = selectedIndex === 0 ? "keywords" : "keywords_ui";
  $: if (selectedIndex >= 0) (selectedKeywordIds = []);

  $: if (regexModalOpen === false) preview = "";

  $: {
    if (selectedIndex === 0) {
      type = "am_windowtitle";
    } else if (selectedIndex === 1 && selectedUIElementIndex === 1) {
      type = "ui_automationid";
    } else {
      type = "ui_name";
    }
  }

  $: {
    loadingKeyword = true;
    fetchWithSession(
      `/api/damprojects/getKeywords?idproject=${idproject}&projectstep=1&type=${type}`
    )
      .then((res) => res.json())
      .then((data) => {
        allRowsKeyword = data;
        rowsKeyword = data;
        hiddenKeyword = data.reduce((acc, row) => {
          acc[row.id] = row.hidden;
          return acc;
        }, {});
        loadingKeyword = false;
      });
  }

  $: {
    fetchWithSession(
      `/api/damprojects/getAnonymizationLog?idproject=${idproject}`
    )
      .then((res) => res.json())
      .then((data) => {
        console.log("getAnonymizationLog", data);
        allwindowtitles = data;
      });
    fetchWithSession(
      `/api/damprojects/getAnonymizationUILog?idproject=${idproject}`
    )
      .then((res) => res.json())
      .then((data) => {
        console.log("getAnonymizationUILog", data);
        allUiElements = data.elements;
      });
  }

  $: {rowsWindowTitle = getWindowTitlesByKeyword(selectedKeywordIds);}


  $: {
    if (!onlyChecked && !onlyUnchecked && !onlyHidden && !onlyUnhidden && !onlyInWindows) {
      rowsKeyword = allRowsKeyword;
    } else {
      let temp = allRowsKeyword;
      if (onlyUnchecked) {
        temp = temp.filter((row) => !selectedKeywordIds.includes(row.id));
      }
      if (onlyChecked) {
        temp = temp.filter((row) => selectedKeywordIds.includes(row.id));
      }
      if (onlyUnhidden) {
        temp = temp.filter((row) => !hiddenKeyword[row.id]);
      }
      if (onlyHidden) {
        temp = temp.filter((row) => hiddenKeyword[row.id]);
      }
      if (onlyInWindows){
        temp = temp.filter((row) => row.applicationname === rowsWindowTitle[0]?.applicationname);
        temp = temp.filter((row) => rowsWindowTitle.some((wt) => wt.windowtitle.match(row.keyword)));
      }
      rowsKeyword = temp;
    }
    hiddenKeyword = hiddenKeyword;
  }

  function generateKeywords() {
    fetchWithSession(
      `/api/damprojects/generateKeywords?idproject=${idproject}&projectstep=1&type=${generateKeywordsType}`
    )
      .then((res) => res.json())
      .then((data) => {
        console.log("GenerateKeywords", data, { generateKeywordsType });
      });
  }

  fetchWithSession(`/api/damprojects/getProjectAnonymizations/${idproject}/2`)
    .then((res) => res.json())
    .then((data) => {
      idAnonymization = data;
    });

  function hideKeyword(row) {
    const keywordData = {
      type: type,
      idprojectstep: row.projectstepid,
      applicationname: row.applicationname,
      keyword: row.keyword,
      hidden: !row.hidden,
    };
    fetchWithSession(`/api/damprojects/hideKeyword`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(keywordData),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("hideKeywords", data);
      });
  }
  function generateRegexRules() {
    let temp = allRowsKeyword;
    temp = temp.filter((row) => selectedKeywordIds.includes(row.id));
    if (!temp.length) return;
    fetchWithSession(
      `/api/damprojects/generateRegexFromKeywords?idproject=` + idproject,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ keywords: temp }),
      }
    )
      .then((res) => res.json())
      .then((data) => {
        regexRules = data;
        regexModalOpen = true;
        currentRegex = 0;
        currentApplication = 0;
        loadRegex(0, 0);
      });
  }

  function getWindowTitlesByKeyword(selectedKeywordIds) {
    let selectedKeywordRows = allRowsKeyword.filter(
      (row) => selectedKeywordIds.includes(row.id)
    );
    if (!selectedKeywordRows) return [];

    if (selectedIndex === 1)
      return allUiElements.filter(
        (ui) =>
          ui.applicationname == selectedKeywordRow.applicationname &&
          ui.name.includes(selectedKeywordRow.keyword)
      );
    return allwindowtitles.filter(
      (wt) => 
        selectedKeywordRows.every((selectedKeywordRow) =>
          wt.applicationname == selectedKeywordRow.applicationname &&
          wt.windowtitle.match(selectedKeywordRow.keyword)
        )
    );
  }

  function loadRegex(app, regex) {
    regexRule["name"] =
      "ASSISTANT" +
      " - " +
      regexRules[app].applicationname +
      " - " +
      regexRules[app].regex[regex].rule;
    regexRule["applicationname"] = regexRules[app].applicationname;
    regexRule["search"] = regexRules[app].regex[regex].rule;
    let temp = regexRules[app].regex[regex].rule.replace("(.*?)", "ANONYMIZED");
    regexRule["replace"] = temp.replace(/\\/g, "");
  }

  function nextRegex() {
    currentRegex = currentRegex + 1;
    if (regexRules[currentApplication].regex.length <= currentRegex) {
      currentApplication = currentApplication + 1;
      currentRegex = 0;
      if (regexRules.length <= currentApplication) {
        currentApplication = 0;
      }
    }
    loadRegex(currentApplication, currentRegex);
  }

  function prevRegex() {
    currentRegex = currentRegex - 1;
    if (currentRegex < 0) {
      currentApplication = currentApplication - 1;
      if (currentApplication < 0) {
        currentApplication = regexRules.length - 1;
      }
      currentRegex = regexRules[currentApplication].regex.length - 1;
    }
    loadRegex(currentApplication, currentRegex);
  }

  function showMatched() {
    const selectedKeywordRow = allRowsKeyword.find(
      (row) => row.id === selectedKeywordIds[0]
    );
    if (!selectedKeywordRow) return [];
    if (selectedIndex === 0) {
      preview = allwindowtitles
        .filter(
          (wt) => wt.applicationname == selectedKeywordRow.applicationname
        )
        .filter((wt) => wt.windowtitle.match(regexRule.search))
        .map((wt) => {
          return `${wt.windowtitle} => ${wt.windowtitle.replace(new RegExp(regexRule.search), regexRule.replace)}`;
        })
        .join("\n");
    } else {
      preview = allUiElements
        .filter(
          (wt) => wt.applicationname == selectedKeywordRow.applicationname
        )
        .filter((wt) => wt.name.match(regexRule.search))
        .map((wt) => {
          return `${wt.name} => ${wt.name.replace(new RegExp(regexRule.search), regexRule.replace)}`;
        })
        .join("\n");
    }
  }

  function showUnmatched() {
    const selectedKeywordRow = allRowsKeyword.find(
      (row) => row.id === selectedKeywordIds[0]
    );
    if (!selectedKeywordRow) return [];
    if (selectedIndex === 0) {
      preview = allwindowtitles
        .filter(
          (wt) => wt.applicationname == selectedKeywordRow.applicationname
        )
        .filter((wt) => !wt.windowtitle.match(regexRule.search))
        .map((wt) => wt.windowtitle)
        .join("\n");
    } else {
      preview = allUiElements
        .filter(
          (wt) => wt.applicationname == selectedKeywordRow.applicationname
        )
        .filter((wt) => !wt.name.match(regexRule.search))
        .map((wt) => wt.name)
        .join("\n");
    }
  }

  function saveRegex() {
    let payload = {
      idanonymizationrules: idAnonymization,
      id: 0,
      ...regexRule,
    };

    fetchWithSession(`/api/damprojects/saveDAMAnonymizationRule?preset=false`, {
      method: "POST",
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
  }
  $$restProps;
</script>


<Header section="Keyword Support" breadcrumb="Assistant">
  <ButtonNew
    text="Generate Keywords"
    setting={true}
    secondary={true}
    on:click={generateKeywords}
  />
</Header>

<SectionWrapper fullscreen={true}>
  <div class="main" slot="main">
    <div class="table_wrapper" style="width:30vw; ">
      <div class="switcher_wrapper">
        <ContentSwitcher
          bind:selected={selectedIndex}
          options={["WindowTitle", "UI Elements"]}
          fitContent={true}
        />
        {#if selectedIndex === 1}
          <ContentSwitcher
            bind:selected={selectedUIElementIndex}
            options={["UI Name", "UI AutomationId"]}
            fitContent={true}
          />
        {/if}
      </div>
      <div class="filter_wrapper">
        <Checkbox
          bind:checked={onlyUnchecked}
          labelText="Show only unchecked"
        />
        <Checkbox bind:checked={onlyChecked} labelText="Show only checked" />
        <Checkbox bind:checked={onlyUnhidden} labelText="Show only unhidden" />
        <Checkbox bind:checked={onlyHidden} labelText="Show only hidden" />
        <Checkbox bind:checked={onlyInWindows} labelText="Show only applicable Keywords" />
      </div>
      {#if loadingKeyword}
        <DataTableSkeleton
          rows={10}
          headers={headersKeyword}
          showToolbar={false}
          showHeader={false}
          size="short"
        />
      {:else}
        <DataTable
          selectable
          size="compact"
          headers={headersKeyword}
          rows={rowsKeyword}
          sortable
          sortKey={defaultSortKeyword.key}
          sortDirection={defaultSortKeyword.order}
          pageSize={paginationKeyword.pageSize}
          page={paginationKeyword.page}
          bind:selectedRowIds={selectedKeywordIds}
        >
          <Toolbar>
            <ToolbarContent>
              <ToolbarSearch shouldFilterRows bind:rowsKeyword persistent />
              <!-- <ButtonIcon
                icon="plus"
                on:click={() => {
                  console.log("Clicked New");
                }}
                disable
              /> -->
            </ToolbarContent>
          </Toolbar>
          <svelte:fragment slot="cell" let:row let:cell>
            {#if cell.key === "hide"}
              <Checkbox
                bind:checked={hiddenKeyword[row.id]}
                bind:hiddenKeyword
                on:change={hideKeyword(row)}
              />
            {:else}
              {cell.value}
            {/if}
          </svelte:fragment>
        </DataTable>
        <Pagination
          bind:pageSize={paginationKeyword.pageSize}
          bind:page={paginationKeyword.page}
          totalItems={rowsKeyword.length}
          pageSizes={[10, 25, 50, 75, 100]}
        />
      {/if}
    </div>
    <div class="table_wrapper" style="width: 15vw; margin-top: 3.25rem;">
      {#if loadingWindowTitle}
        <DataTableSkeleton
          rows={10}
          headers={headersWindowTitle}
          showToolbar={false}
          showHeader={false}
          size="short"
        />
      {:else}
        <DataTable
          size="compact"
          headers={headersWindowTitle}
          rows={rowsWindowTitle}
          sortable
          sortKey={defaultSortWindowTitle.key}
          sortDirection={defaultSortWindowTitle.order}
          pageSize={paginationWindowTitle.pageSize}
          page={paginationWindowTitle.page}
        >
          <Toolbar>
            <ToolbarContent>
              <ToolbarSearch shouldFilterRows bind:rowsWindowTitle persistent />
            </ToolbarContent>
          </Toolbar>
        </DataTable>
        <Pagination
          bind:pageSize={paginationWindowTitle.pageSize}
          bind:page={paginationWindowTitle.page}
          totalItems={rowsWindowTitle.length}
          pageSizes={[10, 25, 50, 75, 100]}
        />
      {/if}
      <div style="">
        <ButtonNew
          text="Generate Rules"
          setting={true}
          secondary={true}
          disabled={selectedKeywordIds.length === 0}
          on:click={selectedKeywordIds.length === 0 ? null : generateRegexRules}
        />
      </div>
    </div>
  </div>
</SectionWrapper>
<Modal
  preventCloseOnClickOutside
  bind:open={regexModalOpen}
  modalHeading="Generate Regex Rules"
  passiveModal
  size="lg"
>
  <TextInput id="text-input-1" labelText="Name" value={regexRule.name} />
  <TextInput
    id="text-input-1"
    labelText="Application Name"
    value={regexRule.applicationname}
  />
  <TextInput id="text-input-2" labelText="Search" value={regexRule.search} />
  <TextInput id="text-input-3" labelText="Replace" value={regexRule.replace} />
  <div class="button_wrapper">
    <ButtonNew
      text="Back"
      setting={true}
      secondary={true}
      on:click={prevRegex}
    />
    <ButtonNew
      text="Next"
      setting={true}
      secondary={true}
      on:click={nextRegex}
    />
    <ButtonNew text="Save" setting={true} on:click={saveRegex} />
  </div>
  <div class="button_wrapper">
    <ButtonNew
      text="Show Matched"
      setting={true}
      secondary={true}
      on:click={showMatched}
    />
    <ButtonNew
      text="Show Unmatched"
      setting={true}
      secondary={true}
      on:click={showUnmatched}
    />
    <ButtonNew
      text="Clear"
      setting={true}
      secondary={true}
      on:click={() => {
        preview = "";
      }}
    />
  </div>
  <TextArea value={preview} readonly labelText="Preview" />
</Modal>

<style>
  .main {
    max-width: 100%;
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 1rem;
  }

  .table_wrapper {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .filter_wrapper {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    margin-top: 0.5rem;
    margin-bottom: 1rem;
  }

  .switcher_wrapper {
    display: flex;
    flex-direction: row;
    gap: 1rem;
  }

  .button_wrapper {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    margin-top: 1rem;
  }

  :global(.filter_wrapper .bx--form-item.bx--checkbox-wrapper:first-of-type) {
    margin-top: 0 !important;
  }
</style>
